import { useEffect } from "react";
let users = 0;
const sync = () => {
    if (document.visibilityState === "hidden")
        document.documentElement.dataset.pageHidden = "";
    else
        delete document.documentElement.dataset.pageHidden;
};
/**
 * While a component that uses it is mounted, the looping animations of the
 * library (breathing, shimmer, scan, caret) pause when the tab is hidden
 * (the data-page-hidden attribute on <html>, see theme.css).
 */
export function usePauseWhenHidden() {
    useEffect(() => {
        if (typeof document === "undefined")
            return;
        if (users++ === 0) {
            document.addEventListener("visibilitychange", sync);
            sync();
        }
        return () => {
            if (--users === 0) {
                document.removeEventListener("visibilitychange", sync);
                delete document.documentElement.dataset.pageHidden;
            }
        };
    }, []);
}
